// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c2oD","col":"styles_col__2b8xA"};